export default {
  getMunicipalities: (state) => state.municipalities,
};
